import { useCallback } from "react";
import { Select } from "antd";
import { useRequest } from "ahooks";
import { setting as settingService } from "@/services";

function ColleagueSelect({ token, value, onChange }) {
  const { data = [], loading } = useRequest(
    () => settingService.listColleague(token),
    {
      ready: !!token,
      refreshDeps: [token],
    }
  );

  const changeHandler = useCallback(
    (value) => {
      onChange(value);
    },
    [onChange]
  );

  const optionItems = data.map((item) => (
    <Select.Option key={item.id} value={item.id}>
      {item.username}
    </Select.Option>
  ));

  return (
    <Select
      loading={loading}
      value={value}
      onChange={changeHandler}
      style={{ width: "200px" }}
    >
      {optionItems}
    </Select>
  );
}

export default ColleagueSelect;
